import React from 'react';
import { AlertCircle, CheckCircle2, ArrowRight } from 'lucide-react';
import { CASE_STUDIES } from '../mock';

const CaseCard = ({ study }) => {
  return (
    <div className="group relative rounded-3xl border border-slate-200 bg-white p-7 lg:p-8 hover:border-slate-300 hover:shadow-xl hover:shadow-slate-900/5 transition-all duration-300 flex flex-col">
      {/* Domain badge */}
      <div className="flex items-center justify-between gap-3">
        <span
          className={`inline-flex items-center rounded-full px-3 py-1 text-[10.5px] font-semibold uppercase tracking-[0.14em] text-white whitespace-nowrap bg-gradient-to-r ${study.accent}`}
        >
          {study.domain}
        </span>
        <span className="text-[10.5px] font-medium tracking-[0.16em] text-slate-400 uppercase whitespace-nowrap">
          Scenario
        </span>
      </div>

      <h3 className="mt-5 font-display text-[22px] leading-tight font-semibold text-slate-900 tracking-tight">
        {study.title}
      </h3>

      <div className="mt-5 space-y-4">
        <div>
          <div className="flex items-center gap-2 text-[11.5px] font-semibold text-red-600 uppercase tracking-[0.14em]">
            <AlertCircle size={13} strokeWidth={2.5} />
            The problem
          </div>
          <p className="mt-1.5 text-[14px] leading-relaxed text-slate-600">
            {study.problem}
          </p>
        </div>

        <div>
          <div className="flex items-center gap-2 text-[11.5px] font-semibold text-emerald-600 uppercase tracking-[0.14em]">
            <CheckCircle2 size={13} strokeWidth={2.5} />
            What we built
          </div>
          <p className="mt-1.5 text-[14px] leading-relaxed text-slate-600">
            {study.outcome}
          </p>
        </div>
      </div>

      {/* Metric */}
      <div className="mt-6 pt-6 border-t border-slate-100 flex items-end justify-between gap-4">
        <div>
          <div className="font-display text-[32px] leading-none font-semibold text-slate-900 tracking-tight">
            {study.metric}
          </div>
          <div className="mt-1 text-[12.5px] text-slate-500">{study.metricLabel}</div>
        </div>
        <a
          href="#contact"
          className="inline-flex items-center gap-1 text-[13px] font-medium text-slate-500 hover:text-slate-900 transition-colors"
        >
          Discuss a similar case
          <ArrowRight
            size={14}
            className="transition-transform group-hover:translate-x-0.5"
          />
        </a>
      </div>
    </div>
  );
};

const CaseStudies = () => {
  return (
    <section className="relative py-24 lg:py-32 bg-slate-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-[12px] font-medium text-slate-700 uppercase tracking-[0.18em]">
            Proven Scenarios
          </div>
          <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-semibold tracking-tight text-slate-900">
            Real problems.{' '}
            <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">
              Real code shipped.
            </span>
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-slate-600">
            A snapshot of automation, resilience and chaos-engineering work our founder has delivered before Scatura - the kinds of outcomes you can expect from your first engagement.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CASE_STUDIES.map((c) => (
            <CaseCard key={c.id} study={c} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
